<div class="settings-wrapper">
  <div class="settings-menu-wrapper">
    <dx-tree-view
      [dataSource]="settingsTabsItems"
      itemTemplate="items"
      [displayExpr]="'text'"
      [keyExpr]="'id'"
      dataStructure="plain"
      [parentIdExpr]="'parentId'"
      (onItemClick)="onItemClick($event)"
    >
      <div
        *dxTemplate="let item of 'items'"
        class="tab-header-item"
        [class.active-tab]="item.id === activeTab.id"
        [class.fixed]="item.index === 9999"
        (mouseenter)="showTooltip($event, item)"
        (mouseleave)="hideTooltip()"
      >
        <mat-icon [svgIcon]="item.icon ?? 'arenaGeneral'"></mat-icon>

        <span class="tab-title-text">{{ item.text }}</span>
      </div>
    </dx-tree-view>
    <dx-tooltip [target]="tooltipTarget" [(visible)]="tooltipVisible" position="bottom" class="tree-view-tooltip">
      <div *dxTemplate="let content of 'content'">
        {{ tooltipContent }}
      </div>
    </dx-tooltip>
  </div>
  <div class="tab-content-wrapper">
    @if (activeTab && activeTab.id !== SettingsPageEnum.UserInfo) {
      <div class="tab-content-header">
        <h3>{{ activeTab.text }}</h3>
      </div>
    }

    <!-- ? Allgemein Tab -->
    <div [hidden]="activeTab && activeTab.id !== SettingsPageEnum.General">
      <div class="tab-section-wrapper">
        <div class="tab-content-section">
          <h4 class="section-title">{{ translator('Arena-Language') }}</h4>

          <abc-drop-down-box
            [id]="'language'"
            [width]="'100%'"
            [disabled]="isLanguageDisabled"
            [label]="translator('Arena-Language')"
            labelMode="floating"
            [gridColumns]="dropdownLanguagesGridColumns"
            [dataSource]="languageOptions"
            hidePicklistValueColumn="true"
            [hideColumnHeaders]="true"
            valueExpr="Value"
            displayExpr="Description"
            [(value)]="selectedAccountLnguage"
            (onValueChanged)="handleChangeStates()"
          >
          </abc-drop-down-box>
        </div>

        <div class="tab-content-section" id="General"></div>
      </div>
    </div>

    <!-- ? Layout Tab -->
    <div [hidden]="activeTab && activeTab.id !== SettingsPageEnum.Layout">
      <div class="tab-section-wrapper">
        <div class="tab-content-section">
          <h4 class="section-title">{{ translator('Arena-Style') }}</h4>

          <abc-drop-down-box
            [id]="'stylingMode'"
            [label]="translator('Arena-StylingMode')"
            labelMode="floating"
            [dataSource]="stylingModeOptions"
            [(value)]="selectedStyleMode"
            valueExpr="value"
            displayExpr="label"
            [hideColumnHeaders]="true"
            [gridColumns]="generalDropdownGridColumns"
            (onValueChanged)="handleChangeStates()"
          >
          </abc-drop-down-box>

          <abc-drop-down-box
            [(value)]="selectedDisplayMode"
            [label]="translator('Arena-AppearanceStyle')"
            labelMode="floating"
            [dataSource]="displayStyleOptions"
            [gridColumns]="generalDropdownGridColumns"
            [hideColumnHeaders]="true"
            valueExpr="value"
            displayExpr="label"
            (onValueChanged)="handleChangeStates()"
          >
          </abc-drop-down-box>

          <abc-drop-down-box
            [(value)]="selectedLayoutSplitterOrientation"
            [label]="translator('Arena-LayoutSplitterOrientation')"
            labelMode="floating"
            [dataSource]="layoutSplitterOrientationOptions"
            valueExpr="value"
            displayExpr="label"
            [gridColumns]="generalDropdownGridColumns"
            (onValueChanged)="handleChangeStates()"
            [hideColumnHeaders]="true"
          >
          </abc-drop-down-box>

          <abc-drop-down-box
            [(value)]="selectedTheme"
            [label]="translator('Arena-Theme')"
            labelMode="floating"
            [dataSource]="themeOptions"
            [gridColumns]="generalDropdownGridColumns"
            [hideColumnHeaders]="true"
            valueExpr="value"
            displayExpr="label"
            (onValueChanged)="handleChangeStates()"
          >
          </abc-drop-down-box>

          <div class="custom-dropdown-wrapper">
            <abc-drop-down-box
              #stylingSelect
              [width]="'100%'"
              [(value)]="selectedStylingOption"
              [label]="translator('Arena-ColorSchema')"
              labelMode="floating"
              valueExpr="value"
              displayExpr="label"
              [dataSource]="arenaStylingData"
              [gridColumns]="generalDropdownGridColumns"
              [hideColumnHeaders]="true"
              (onValueChanged)="handleChangeStates()"
            >
            </abc-drop-down-box>

            <input
              type="file"
              #fileInput
              style="display: none"
              accept=".json"
              [multiple]="false"
              (change)="onFileSelected($event)"
            />

            <abc-button
              id="abcCenNavigationButtonsNext"
              class="abc-cen-navigation-buttons-next upload-btn"
              [icon]="'upload'"
              [hint]="translator('Arena-UploadDocument-btn-hint')"
              (onClick)="fileInput.click()"
            >
            </abc-button>
          </div>
        </div>

        <div class="tab-content-section" id="Layout"></div>
      </div>
    </div>

    <!-- ? User Info Tab -->
    <div [hidden]="activeTab && activeTab.id !== SettingsPageEnum.UserInfo">
      <abc-management-users-user-settings
        #userSettings
        [allowUserNameChange]="true"
        [allowPasswordChange]="true"
        [showActionButtons]="false"
        (changedEvent)="onUserInfoChanged()"
      >
      </abc-management-users-user-settings>
    </div>

    <!-- ? Version Tab -->
    <div [hidden]="activeTab && activeTab.id !== SettingsPageEnum.Version">
      <div class="tab-section-wrapper">
        <div class="tab-content-section">
          <div class="version-info-rows-container">
            <div class="version-info-row">
              <h4 class="info-label">{{ translator('Arena-version') }}</h4>
              <p class="info-version">{{ versionInfo || translator('Arena-No-Data') }}</p>
              <mat-icon class="copy-icon" svgIcon="copy" (click)="copyToClipboard(versionInfo)"></mat-icon>
            </div>
            <div class="version-info-row">
              <h4 class="info-label">{{ translator('Arena-build') }}</h4>
              <p class="info-version">{{ buildNumber || translator('Arena-No-Data') }}</p>
              <mat-icon class="copy-icon" svgIcon="copy" (click)="copyToClipboard(buildNumber)"></mat-icon>
            </div>
            <div class="version-info-row">
              <h4 class="info-label">{{ translator('Arena-build-date') }}</h4>
              <p class="info-version">{{ buildDate || translator('Arena-No-Data') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ? Additional Tab -->
    <div [hidden]="activeTab && activeTab.type !== SettingsPageEnum.Additional">
      @if (selectedAdditionalComponent) {
        <ng-container #dynamicHost [ngComponentOutlet]="selectedAdditionalComponent"> </ng-container>
      }
    </div>
  </div>
</div>

<div class="settings-footer-container">
  <!-- refresh info -->
  <div class="refresh-info">
    @if (requiresPageRefresh && !errorMessageText) {
      <mat-icon class="refresh-icon" svgIcon="arena-refresh"></mat-icon>
      <span class="refresh-text">{{ translator('Arena-refresh-info') }}</span>
    }
    @if (!requiresPageRefresh && hasPendingChanges && !errorMessageText) {
      <mat-icon class="refresh-icon" svgIcon="konfiguration-speichern"></mat-icon>
      <span class="refresh-text">{{ translator('Arena-settings-UnsavedChanges-warning') }}</span>
    }

    @if (errorMessageText) {
      <i class="dx-icon dx-icon-clear error-icon"></i>
      <span class="error-text">{{ errorMessageText }}</span>
    }
  </div>

  <div class="btn-settings">
    <abc-button
      class="saveBtn"
      [ngClass]="{ enabled: hasPendingChanges || requiresPageRefresh }"
      [disabled]="!(hasPendingChanges || requiresPageRefresh)"
      text="{{ translator('Arena-save-btn') }}"
      (onClick)="save()"
    ></abc-button>
    <abc-button
      class="cancelBtn"
      [ngClass]="{ enabled: hasPendingChanges || requiresPageRefresh }"
      text="{{ translator('Arena-cancel-btn') }}"
      (onClick)="cancel()"
    ></abc-button>
  </div>
</div>
